import React from 'react';
import clsx, { ClassValue } from 'clsx';
import { useExperimentsStore } from 'apps/experiments/src/store';
import { useTranslation } from 'common/i18n/hooks';
import { InputReact } from 'common/components/input';
import { InputSize } from 'common/components/input/types';
import { PageTrackingEvent, trackExperimentPageAction, TrackingEventSource } from 'apps/experiments/src/components/tracking';
import { useUpdateExperiment } from 'iron/apps/experiments/src/components/hooks/update-experiment';
import { useExperimentPageContext } from 'iron/apps/experiments/src/components/context';
import { ExperimentPageSummaryCard } from './card';
import styles from './_hypothesis-card.module.styl';
type HypothesisSummaryCardProps = {
  className?: ClassValue;
};
export const HypothesisSummaryCard = (props: HypothesisSummaryCardProps) => {
  var _experimentState$hypo;
  const {
    canEdit
  } = useExperimentPageContext();
  const experimentState = useExperimentsStore(state => state.experimentState!);
  const i18n = useTranslation();
  const updateExperiment = useUpdateExperiment();
  const onUpdateHypothesis = React.useCallback((hypothesis: string) => {
    updateExperiment({
      hypothesis
    });
    hypothesis = hypothesis || "";
    trackExperimentPageAction({
      event: PageTrackingEvent.EditHypothesis,
      experiment: experimentState,
      source: TrackingEventSource.ExperimentPage,
      props: {
        hypothesis,
        'hypothesis - length': hypothesis.length
      }
    });
  }, [experimentState, updateExperiment]);
  return <ExperimentPageSummaryCard className={clsx(props.className)} header={<div>{i18n.t("experiments.main.summary.hypothesis")}</div>} data-sentry-element="ExperimentPageSummaryCard" data-sentry-component="HypothesisSummaryCard" data-sentry-source-file="_hypothesis-card.tsx">
      <InputReact className={styles.fullSize} size={InputSize.Large} type='textarea' value={(_experimentState$hypo = experimentState.hypothesis) !== null && _experimentState$hypo !== void 0 ? _experimentState$hypo : ""} placeholder={i18n.t("experiments.main.summary.hypothesis-placeholder")} readonly={!canEdit} onChange={(ev: TODO) => {
      onUpdateHypothesis(ev.detail.value);
    }} data-sentry-element="InputReact" data-sentry-source-file="_hypothesis-card.tsx" />
    </ExperimentPageSummaryCard>;
};